/* eslint-disable no-alert */

import { api, stickyMessage } from './util';

(function ($) {
	$('#dis-analytic-show-erecept').click(function () {
		$('#erecept-search-form').submit();
	});

	$('#district-toggle').click(function () {
		let toggle = $(this);

		if (toggle.text() === 'Odznačit všechny') {
			toggle.text('Označit všechny');
			$('#erecept-search-form input[name=district]').prop('checked', false);
		} else {
			toggle.text('Odznačit všechny');
			$('#erecept-search-form input[name=district]').prop('checked', true);
		}
	});

	let getGeographicalGroupByCount = function () {
		let count = 0;

		$('#erecept-content select[name=group-by] option.type-geographical:selected').each(function () {
			count++;
		});

		return count;
	};

	let getStandardGroupByCount = function () {
		let count = 0;

		$('#erecept-content select[name=group-by] option.type-standard:selected').each(function () {
			count++;
		});

		return count;
	};

	/**
	 * Allowing Map View Type
	 */
	let toggleMapViewType = function () {
		let ereceptMapInput = $('#ereceptmap');
		let ereceptMapTooltip = $('#erecept-map-tooltip');

		let usage = $('#erecept-content input[name=usage]:checked').val();

		if (getStandardGroupByCount() === 1 && getGeographicalGroupByCount() === 1 && usage === 'custom') {
			ereceptMapInput.removeAttr('disabled');
			ereceptMapTooltip.css('opacity', 1);
			ereceptMapTooltip.css('cursor', 'Pointer');
		} else {
			ereceptMapInput.attr('disabled', 'disabled');
			ereceptMapTooltip.css('opacity', 0.5);
			ereceptMapTooltip.css('cursor', 'default');
		}
	};

	let toggleAddingGroupBy = function () {
		let viewType = $('#erecept-content input[name=view-type]:checked').val();

		if (viewType === 'map') {
			$('#erecept-content .groupby-geographical-warning').show();
			$('#erecept-content .groupby-select-in').css('padding-right', '0');
			$('#erecept-content .groupby-select-remove').hide();
			let groupByCount = $('#erecept-content select[name=group-by] option:selected').length;

			if (groupByCount >= 2) {
				$('#erecept-content .dis-13-add-group-by').hide();
				let i = 0;

				$('#erecept-content .groupby-select-in').each(function () {
					if ($(this).hasClass('groupby-select-in-template') || $(this).hasClass('groupby-control')) {
						return;
					}

					i++;
					if (i > 2) {
						$(this).remove();
					}
				});
			} else {
				$('#erecept-content .dis-13-add-group-by').show();
			}
		} else {
			let groupByCount = $('#erecept-content select[name=group-by] option:selected').length;
			$('#erecept-content .groupby-geographical-warning').hide();
			$('#erecept-content .groupby-select-in').css('padding-right', '32px');
			$('#erecept-content .groupby-select-remove').show();

			if (groupByCount > 4) {
				$('#erecept-content .dis-13-add-group-by').hide();
			} else {
				$('#erecept-content .dis-13-add-group-by').show();
			}
		}
	};

	toggleMapViewType();
	toggleAddingGroupBy();

	$(document).on('click', '#erecept-content .groupby-select-remove', function () {
		toggleMapViewType();
		toggleAddingGroupBy();
	});
	$(document).on('change', '#erecept-content select[name=group-by]', function () {
		toggleMapViewType();
		toggleAddingGroupBy();
	});
	$(document).on('change', '#erecept-content input[name=view-type], #erecept-content input[name=usage]', function () {
		toggleMapViewType();
		toggleAddingGroupBy();
	});

	let ereceptFormValidation = function () {
		if ($('#erecept-content input[name=usage]:checked').val() === 'custom') {
			// Missing Group By check
			let noGroupBy = true;

			$('#erecept-content select[name=group-by]').each(function () {
				if ($(this).val() !== '') {
					noGroupBy = false;
				}
			});

			if (noGroupBy) {
				alert('Prosím vyberte alespoň jedno seskupení.');
				return false;
			}

			// Missing district
			if ($('#erecept-content input[name=district]:checked').length === 0) {
				alert('Prosím vyberte nějaký district');
				return false;
			}
		}

		let viewTypeVal = $('#erecept-content input[name=view-type]:checked').val();
		if (viewTypeVal === undefined) {
			alert('Prosím zvolte, jakým způsobem chceme zobrazit data');
			return false;
		}

		if (viewTypeVal === 'map') {
			if (getStandardGroupByCount() !== 1 || getGeographicalGroupByCount() !== 1) {
				alert('Pro zobrazení pomocí mapy je nutné zvolit právě jedno geografické a jedno standardní seskupení');
				return false;
			}
		}

		if ($('#erecept-content input[name=period]:checked').val() === undefined) {
			alert('Prosím zvolte periodu');
			return false;
		}
	};

	/**
	 * Zaměňování is weird and we don't want to allow other options than standard unit.
	 */
	let zamenovaniDisableOptionsFunction = function () {
		let metric = $('#erecept-search-form select[name=metric]');
		if (metric.length === 0) {
			return;
		}

		let val = metric.val();
		if (val === 'zamenovani') {
			$('#erecept-search-form #erecept-unit label').addClass('disabled');
			$('#erecept-search-form #erecept-unit input').attr('disabled', true);
			$('#erecept-search-form #erecept-unit .erecept-unit-value').removeClass('disabled');
			$('#erecept-search-form #erecept-unit input[value=value]').attr('disabled', false);
			$('#erecept-search-form input[name=unit][value=value]').prop('checked', true);
		} else {
			$('#erecept-search-form #erecept-unit label').removeClass('disabled');
			$('#erecept-search-form #erecept-unit input').attr('disabled', false);
		}
	};

	$('#erecept-search-form select[name=metric]').change(function () {
		zamenovaniDisableOptionsFunction();
	});
	zamenovaniDisableOptionsFunction();

	/**
	 * Toggle district config. Hidden by default.
	 */
	let showDistricts = function () {
		$('#erecept-content .district-config').show();
		$('#erecept-content #district-toggle').css('display', 'inline-block');
		$('#erecept-content #district-config-toggle-plus').hide();
		$('#erecept-content #district-config-toggle-minus').show();
	};

	let hideDistricts = function () {
		$('#erecept-content .district-config').hide();
		$('#erecept-content #district-config-toggle-plus').show();
		$('#erecept-content #district-config-toggle-minus').hide();
	};

	let totalInputs = $('#erecept-content .district-config input[name=district]:checked').length;
	let checkedInputs = $('#erecept-content .district-config input[name=district]').length;

	if (totalInputs !== checkedInputs) {
		showDistricts();
	}

	$('#district-config-toggle').click(function () {
		if ($('#erecept-content #district-toggle').css('display') === 'none') {
			showDistricts();
		} else {
			hideDistricts();
		}
	});

	/**
	 * Toggle districts in region
	 */
	$('#erecept-content .region-config .dis-title').click(function () {
		let regionConfig = $(this).parent();
		if (regionConfig.find('input').length === regionConfig.find('input:checked').length) {
			regionConfig.find('input').prop('checked', false);
		} else {
			regionConfig.find('input').prop('checked', true);
		}
	});

	/**
	 * Map has tooltip with some info, we want to highlight those areas for better UX
	 */
	$('#erecept-map-tooltip').hover(
		function () {
			if ($('#erecept-content input[name=view-type]:checked').val() === 'map') {
				return;
			}

			$('#erecept-custom-usage-label .like-radio').css('background', 'lightyellow');
			$('.groupby').css('background', 'lightyellow');
		},
		function () {
			$('#erecept-custom-usage-label .like-radio').css('background', 'transparent');
			$('.groupby').css('background', 'transparent');
		}
	);

	/**
	 * Form submit
	 */
	$('#erecept-search-form').submit(function (event) {
		if (ereceptFormValidation() === false) {
			return false;
		}

		// There is too many districts => we need to reformat the URL because of Edge 2048 character limit :facepalm:
		let form = $('#erecept-search-form');
		let url = form.attr('action');
		let search = new URLSearchParams(new FormData(form[0]).entries());

		let districts = [];
		$('#erecept-search-form input[name=district]:checked').each(function () {
			districts.push($(this).val());
		});

		search.set('district', districts);
		window.location = `${url}?${search.toString()}`;
		$('#erecept-analytic-submit').prop('disabled', true);
		return false;
	});

	/**
	 * Generating .xls
	 * @Fixme: This is basically copy&paste from `product-analytic-dis-13.js`, only with different validation - should be probably unified w/ other DIS (LP, MD)
	 */
	$(document).on('click', '.erecept-module-js-export', function () {
		let btn = $(this);
		let originalText = btn.text();
		let url = btn.attr('data-href');
		let data = $('#erecept-search-form').serialize();

		if (btn.hasClass('generating') || ereceptFormValidation() === false) {
			return;
		}

		btn.addClass('generating');
		btn.text('Generuji .xls');

		api
			.get(`${url}?${data}`)
			.done(function (response) {
				if (response.status.success === false) {
					stickyMessage.show('error', response.status.message);
					return;
				}

				if (response.export.downloadUrl) {
					window.location.href = response.export.downloadUrl;
				} else {
					stickyMessage.show(
						'success',
						`Export je příliš velký. Po zpracování vám pošleme odkaz pro stažení na email ${response.export.asyncNotification.email}`
					);
				}
			})
			.always(function () {
				btn.removeClass('generating');
				btn.text(originalText);
			});

		return false;
	});
})(jQuery);
